import React, { useCallback, useState } from 'react';
import { Container, Box, Snackbar, Typography } from '@mui/material';
import { getCourseStructure } from '../csvImport';
import { updateCourses } from '../firebaseConnection/database';
import Dropzone from '../hooks/Dropzone';

const CourseImportPage = (): JSX.Element => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');

  const onDrop = useCallback(async (acceptedFiles: File[]) => {
    if (acceptedFiles[0]) {
      try {
        const firebaseData = await getCourseStructure(acceptedFiles[0]);
        delete firebaseData.undefined;
        delete firebaseData[''];
        console.log(firebaseData);
        await updateCourses(firebaseData);

        setMessage('Success!');
        setOpen(true);
      } catch (e) {
        setMessage(`Error: ${e}`);
        setOpen(true);
      }
      setOpen(true);
    }
  }, []);

  return (
    <>
      <Container sx={{ width: `calc(100% - ${240}px)`, ml: `${240}px` }}>
        <Box
          component="main"
          sx={{ flexGrow: 1, bgcolor: 'background.default', p: 3 }}
        >
          <Typography variant="h4">Schulungen</Typography>

          <Dropzone drop={csvFile => onDrop(csvFile)} />
        </Box>
        <Snackbar
          open={open}
          autoHideDuration={6000}
          onClose={() => setOpen(false)}
          message={message}
        />
      </Container>
    </>
  );
};

export default CourseImportPage;
